// файл Protected.js

import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode'; // Исправленный импорт
import { Link } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi'; // Импортируем иконку стрелочки вниз
import debounce from 'lodash.debounce'; // Для оптимизации поиска

const Protected = () => {
  const [message, setMessage] = useState('');
  const [timeLeft, setTimeLeft] = useState(null);
  const [widgetVisible, setWidgetVisible] = useState(false);

  // Состояния для поиска
  const [query, setQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  // Данные из API
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      setMessage('Сначала выполните вход!');
      return;
    }

    let decodedToken;
    try {
      decodedToken = jwtDecode(token);
    } catch (err) {
      setMessage('Неверный токен.');
      return;
    }

    const expirationTime = decodedToken.exp * 1000;

    // Функция для обновления времени до истечения токена
    const updateTimeLeft = () => {
      const timeRemaining = expirationTime - Date.now();
      if (timeRemaining <= 0) {
        setMessage('Срок действия токена истек.');
        clearTimeout(timer);
      } else {
        const minutes = Math.floor(timeRemaining / 60000);
        const seconds = Math.floor((timeRemaining % 60000) / 1000);
        setTimeLeft(`${minutes}м ${seconds}с`);
      }
    };

    // Обновляем оставшееся время токена каждую секунду
    const timer = setInterval(updateTimeLeft, 1000);
    updateTimeLeft();

    // Запрос данных с API, передача токена в заголовке Authorization
    fetch('/api/accs', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setSearchData(data))
      .catch(() => setMessage('Ошибка при получении данных с API.'));

    return () => clearInterval(timer); // Очистка таймера при размонтировании
  }, []);

  const handleWidgetClick = () => setWidgetVisible(true); // Открытие виджета
  const closeWidget = () => setWidgetVisible(false); // Закрытие виджета

  // Оптимизированная функция поиска
  const debouncedSearch = debounce((query) => {
    const results = searchData.filter((item) =>
      item.clt_name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(results);
    setDropdownVisible(query.length > 0 && results.length > 0); // Отображение выпадающего списка
  }, 300);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setQuery(query);
    debouncedSearch(query); // Запуск поиска
    setHighlightedIndex(0); // Сбрасываем выделение
  };

  // Фокус на поле поиска открывает выпадающий список
  const handleSearchFocus = () => {
    setFilteredData(searchData); // Показываем все данные
    setDropdownVisible(true); // Открываем выпадающий список
  };

  const handleSelectItem = (item) => {
    setQuery(`${item.clt_name} | ${item.clt_account}`); // Отображаем выбранный элемент в поле
    setDropdownVisible(false); // Закрываем выпадающий список
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex((prevIndex) => (prevIndex + 1) % filteredData.length); // Навигация вниз
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex((prevIndex) => (prevIndex - 1 + filteredData.length) % filteredData.length); // Навигация вверх
    } else if (e.key === 'Enter') {
      if (isDropdownVisible && filteredData[highlightedIndex]) {
        e.preventDefault();
        handleSelectItem(filteredData[highlightedIndex]); // Выбор элемента
      }
    } else if (e.key === 'Escape') {
      setDropdownVisible(false); // Закрываем список при нажатии Escape
    }
  };

  const handleDropdownToggle = () => {
    setDropdownVisible(!isDropdownVisible); // Переключение видимости выпадающего списка
    if (!isDropdownVisible) setHighlightedIndex(0);
  };

  return (
    <div style={styles.container}>
      <div style={styles.message}>{message}</div>
      {timeLeft && <div style={styles.timeLeft}>Оставшееся время токена: {timeLeft}</div>}

      {/* Поле поиска */}
      <div style={styles.searchContainer}>
        <input
          type="text"
          value={query}
          onChange={handleSearchChange}
          onFocus={handleSearchFocus} // Открываем список при фокусе
          onKeyDown={handleKeyDown}
          placeholder="Поиск..."
          style={styles.searchInput}
        />
        <div onClick={handleDropdownToggle} style={styles.dropdownButton}>
          <FiChevronDown size={20} color="#fff" />
        </div>
        {isDropdownVisible && (
          <ul style={styles.dropdown}>
            {filteredData.map((item, index) => (
              <li
                key={index}
                onClick={() => handleSelectItem(item)}
                onMouseEnter={() => setHighlightedIndex(index)}
                style={{
                  ...styles.dropdownItem,
                  backgroundColor: highlightedIndex === index ? '#444' : 'transparent',
                }}
              >
                {Object.entries(item).map(([key, value]) => (
                  <span key={key}>
                    {key}: {value}{' '}
                  </span>
                ))}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Кнопка для открытия виджета */}
      <button onClick={handleWidgetClick} style={styles.widgetButton}>Открыть виджет</button>

      {widgetVisible && (
        <div style={styles.widgetOverlay}>
          <div style={styles.widgetContainer}>
            <iframe
              src="/entry"
              title="Виджет"
              style={styles.iframe}
            ></iframe>
            <button onClick={closeWidget} style={styles.closeButton}>Закрыть</button>
          </div>
        </div>
      )}

      {/* Кнопка для перехода на страницу входа */}
      <Link to="/entry" style={styles.loginButton}>Перейти на страницу входа</Link>
    </div>
  );
};

// Стили
const styles = {
  container: {
    backgroundColor: '#121212',
    color: '#ffffff',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    overflow: 'hidden',
    margin: 0,
  },
  message: {
    fontSize: '20px',
    marginBottom: '20px',
  },
  timeLeft: {
    fontSize: '18px',
    marginBottom: '20px',
  },
  searchContainer: {
    position: 'relative',
    width: '75vw', // 75% от ширины экрана
    marginBottom: '20px',
  },
  searchInput: {
    width: '100%', // Заполняет всю ширину контейнера
    padding: '10px',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ccc',
    backgroundColor: '#1a1a1a',
    color: '#fff',
  },
  dropdownButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#333',
    borderRadius: '5px',
    maxHeight: '200px',
    overflowY: 'auto',
    marginTop: '5px',
    zIndex: 10,
  },
  dropdownItem: {
    padding: '10px',
    color: '#fff',
    cursor: 'pointer',
  },
  widgetButton: {
    backgroundColor: '#28a745',
    color: '#ffffff',
    padding: '10px 20px',
    borderRadius: '5px',
    fontSize: '16px',
    border: 'none',
    cursor: 'pointer',
  },
  widgetOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  widgetContainer: {
    position: 'relative',
    width: '80%',
    height: '80%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: '#ff4d4f',
    color: '#fff',
    border: 'none',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loginButton: {
    backgroundColor: '#007bff',
    color: '#ffffff',
    padding: '10px 20px',
    textDecoration: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    marginTop: '20px',
  },
};

export default Protected;